import _ from 'lodash'

class Model {
  static get parsers() {
    return {
      id: id => parseInt(id)
    }
  }

  static one(dataObj) {
    const instance = new this()
    Object.entries(dataObj || {}).forEach(([field, value]) => {
      const parser = this.parsers[field] || (x => x)
      instance[field] = parser(value)
    })
    return instance
  }

  static many(dataArray, sortBy) {
    dataArray = sortBy ? _.sortBy(dataArray, sortBy) : dataArray
    return dataArray.map(data => this.one(data))
  }
}

export default Model
